import { accessData } from "./AppConfig";

//Check if the user has the specified permission
export const PermissionCheck = (permission: string) => {
  const permissions = accessData("permissions");
  return permissions?.includes(permission);
};